"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const createProductsApp_1 = require("./createProductsApp");
const ProductList_happyjoe_1 = require("./ProductList-happyjoe");
const BrandList_happyjoe_1 = require("./BrandList-happyjoe");
const CategoryList_1 = require("./CategoryList");
exports.default = (0, createProductsApp_1.default)({
    ProductListComponent: ProductList_happyjoe_1.default,
    BrandListComponent: BrandList_happyjoe_1.default,
    CategoryListComponent: CategoryList_1.default,
});
